export enum productType {
  CLOUD = 'is-cloud',
  GZ = 'is-gz',
  PARTNER = 'is-partner',
}

export enum ItemsID {
  PATCH_MANAGEMENT = 'patch_management',
  APPLICATION_CONTROL = 'application_control',
  EMAIL_SECURITY = 'email_security',
  ANTI_MALWARE = 'antimalware',
  SECURITY_SERVER = 'security_server',
  MOBILE_SECURITY = 'mobile_security',
  CLOUD_SECURITY = 'cloud_security',
  SECURITY_FOR_EXCHANGE = 'security_for_exchange',
  NETWORK_ATTACK_DEFENSE = 'network_attack_defense',
  CONTENT_CONTROL = 'content_control',
  USING_TAGS = 'using_tags',
  KASEYA = 'kaseya',
  CONNECT_WISE = 'connectwise',
  AMAZON = 'amazon',
}
